export const TRACK_ANIMATION_ACTIONS = {
  TOGGLE_ANIMATION: "TOGGLE_ANIMATION",
  SET_TRACK_INDEX: "SET_TRACK_INDEX",
  SET_TRACK_SPEED: "SET_TRACK_SPEED",
  TOGGLE_SKIP_STOPS: "TOGGLE_SKIP_STOPS",
};
